<h4>Organization History</h4>
@for (event of organization?.history; track event) {
  <div class="grid-x margin-top" [ngClass]="getEventClass(event.eventType)">
    <div class="cell small-4 padding-left">
      {{ event.timeStamp | date: 'M/d/yy | h:mma' }}
    </div>
    <div class="cell small-8 text-align-right padding-right">
      {{ getEventDescription(event) }}
    </div>
  </div>
  <div class="cell text-align-left padding-left" [ngClass]="getEventClass(event.eventType)">
    User: {{ event.contact?.displayName }} | {{ getOrganizationName(event.contact?.organizationId) }}
  </div>
}

